/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Project_Member_SuspendedInputs */

const es_co2_error_project_member_suspended = /** @type {(inputs: Error_Project_Member_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No puedes agregar miembros a un proyecto suspendido.`)
};

/**

* @param {Error_Project_Member_SuspendedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_project_member_suspended = /** @type {((inputs?: Error_Project_Member_SuspendedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Project_Member_SuspendedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_project_member_suspended(inputs)
});